// extracted by mini-css-extract-plugin
export default {"formLabel":"FormLabel_formLabel__XoBiq"};